import { ReactElement, ReactNode, forwardRef, memo } from 'react'
import { Platform } from 'react-native'

import FormControl, { FormControlProps } from 'app/components/base/FormControl'
import TextInputNumber, {
  TextInputNumberProps
} from 'app/components/base/TextInputNumber'
import useFormField, { UseFormFieldProps } from 'app/hooks/useFormField'
import { combineControllerProps } from 'app/utils/helpers/form.helpers'

export interface TextFieldCustomProps extends UseFormFieldProps {
  helperText?: ReactElement | ReactNode | null
  formControlProps?: FormControlProps
  currency?: string
}

export type TextFieldNumberProps = TextFieldCustomProps & TextInputNumberProps

const TextFieldNumber = (
  {
    id: _id,
    helperText,
    label,
    formControlProps,
    ...props
  }: TextFieldNumberProps,
  ref: any
) => {
  const { controllerProps, ...rest } = combineControllerProps(props)
  const { field, error, onChange, value } = useFormField(controllerProps)
  return (
    <FormControl
      errorMessage={error}
      helperText={helperText}
      {...formControlProps}
    >
      <TextInputNumber
        {...field}
        ref={ref}
        error={!!error}
        label={label}
        value={value}
        {...Platform.select({
          web: { onChange },
          native: { onChangeText: onChange }
        })}
        {...rest}
      />
    </FormControl>
  )
}

export default memo(forwardRef(TextFieldNumber))
